var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "admin-content-area",
      attrs: { id: "page-content-wrapper" }
    },
    [
      _c("div", { staticClass: "container-fluid xyz" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "admin-page-content" }, [
          _c("div", { staticClass: "fullblock" }, [
            _c("div", { staticClass: "title" }, [_vm._v("Interactive demo")]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "tooltip-container" },
              [
                _c(
                  "b-container",
                  { attrs: { fluid: "" } },
                  [
                    _c(
                      "b-btn",
                      {
                        attrs: { id: "exButton1", variant: "outline-success" }
                      },
                      [_vm._v("Tooltip")]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-btn",
                      {
                        attrs: { id: "exButton2", variant: "outline-success" }
                      },
                      [_vm._v("Tooltip on top")]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-btn",
                      {
                        attrs: { id: "exButton3", variant: "outline-success" }
                      },
                      [_vm._v("Tooltip on right")]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-btn",
                      {
                        attrs: { id: "exButton4", variant: "outline-success" }
                      },
                      [_vm._v("Tooltip on bottom")]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-btn",
                      {
                        attrs: { id: "exButton5", variant: "outline-success" }
                      },
                      [_vm._v("Tooltip on left")]
                    ),
                    _vm._v(" "),
                    _c("b-tooltip", {
                      attrs: {
                        target: "exButton1",
                        title: "Tooltip",
                        placement: "top"
                      }
                    }),
                    _vm._v(" "),
                    _c("b-tooltip", {
                      attrs: {
                        target: "exButton2",
                        title: "Tooltip on top",
                        placement: "top"
                      }
                    }),
                    _vm._v(" "),
                    _c("b-tooltip", {
                      attrs: {
                        target: "exButton3",
                        title: "Tooltip on right",
                        placement: "right"
                      }
                    }),
                    _vm._v(" "),
                    _c("b-tooltip", {
                      attrs: {
                        target: "exButton4",
                        title: "Tooltip on bottom",
                        placement: "bottom"
                      }
                    }),
                    _vm._v(" "),
                    _c("b-tooltip", {
                      attrs: {
                        target: "exButton5",
                        title: "Tooltip on left",
                        placement: "left"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "fullblock" }, [
            _c("div", { staticClass: "title" }, [_vm._v("Interactive demo")]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "tooltip-container" },
              [
                _c(
                  "b-btn",
                  {
                    directives: [
                      {
                        name: "b-popover",
                        rawName: "v-b-popover.hover.top",
                        value: "I am popover content!",
                        expression: "'I am popover content!'",
                        modifiers: { hover: true, top: true }
                      }
                    ],
                    attrs: { title: "Popover Title" }
                  },
                  [
                    _vm._v(
                      "\n                        Tooltip on Top\n                    "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "b-btn",
                  {
                    directives: [
                      {
                        name: "b-popover",
                        rawName: "v-b-popover.hover.right",
                        value: "I am popover content!",
                        expression: "'I am popover content!'",
                        modifiers: { hover: true, right: true }
                      }
                    ],
                    attrs: { title: "Popover Title" }
                  },
                  [
                    _vm._v(
                      "\n                        Tooltip on Right\n                    "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "b-btn",
                  {
                    directives: [
                      {
                        name: "b-popover",
                        rawName: "v-b-popover.hover.bottom",
                        value: "I am popover content!",
                        expression: "'I am popover content!'",
                        modifiers: { hover: true, bottom: true }
                      }
                    ],
                    attrs: { title: "Popover Title" }
                  },
                  [
                    _vm._v(
                      "\n                        Tooltip on Bottom\n                    "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "b-btn",
                  {
                    directives: [
                      {
                        name: "b-popover",
                        rawName: "v-b-popover.hover.left",
                        value: "I am popover content!",
                        expression: "'I am popover content!'",
                        modifiers: { hover: true, left: true }
                      }
                    ],
                    attrs: { title: "Popover Title" }
                  },
                  [
                    _vm._v(
                      "\n                        Tooltip on Left\n                    "
                    )
                  ]
                )
              ],
              1
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("app-backend-footer")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page-header-top-container" }, [
      _c("div", { staticClass: "page-name" }, [_vm._v("Tooltip & Popover")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6c41c65e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c41c65e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tooltipandpopover.vue
// module id = null
// module chunks = 